export const industry = {
  I100: {
    icon: require('@/assets/icon/industry/I100.png'),
    title: '資訊科技',
  },
  I200: {
    icon: require('@/assets/icon/industry/I200.png'),
    title: '傳產製造',
  },
  I300: {
    icon: require('@/assets/icon/industry/I300.png'),
    title: '工商服務',
  },
  I400: {
    icon: require('@/assets/icon/industry/I400.png'),
    title: '民生服務',
  },
  I500: {
    icon: require('@/assets/icon/industry/I500.png'),
    title: '文教傳播',
  },
};
